import { fetch } from '@atlassian/eoc-fetch';

import { type TimezoneResponse } from '../../../common/types';

export const getTimezonesEndpoint = () => {
	return fetch<TimezoneResponse>(`/v1/customers/timezones`);
};
